<div *ngIf="params.colDef.field === 'status'">
    <mat-slide-toggle
        [(ngModel)]="isActive"
        (change)="toggleStatus($event)"
    ></mat-slide-toggle>
</div>
